import { render } from "./AllOrgs.vue?vue&type=template&id=02b2c6fa&scoped=true"
import script from "./AllOrgs.vue?vue&type=script&lang=js"
export * from "./AllOrgs.vue?vue&type=script&lang=js"

import "./AllOrgs.vue?vue&type=style&index=0&id=02b2c6fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b2c6fa"]])

export default __exports__